import {
  AutorenewRounded,
  BookmarkRounded,
  ClearRounded,
  EditRounded,
  VisibilityRounded,
} from "@mui/icons-material";
import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import React from "react";

const Actions = ({
  param,
  access,
  handleView,
  handleAddEdit,
  handleDlt,
  handleFollowup,
  handleUpdateStatus,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleStatus = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (val) => {
    setAnchorEl(null);
    handleUpdateStatus && handleUpdateStatus(val);
  };

  return (
    <div className="border !border-gray-100 flex gap-2 p-[3px] shadow-sm rounded-[12px] w-fit">
      <Tooltip title="View">
        <IconButton
          onClick={() => handleView(param.id)}
          size="small"
          color="primary"
          className="mr-5 p-5"
        >
          <VisibilityRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>
      {access?.inquery?.status && param.status?.toLowerCase() === "open" && (
        <>
          <div>
            <Tooltip title="Update Status">
              <IconButton
                onClick={handleStatus}
                id="status_menu"
                aria-controls={open ? "status_menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                size="small"
                className=""
              >
                <AutorenewRounded className="!text-[18px]" />
              </IconButton>
            </Tooltip>
            <Menu
              id="status_menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
              PaperProps={{
                className: "bg-white br-6 shadow-sm border !border-gray-200",
              }}
            >
              <MenuItem
                onClick={() => handleClose({ inquiryId: param.id, status: 3 })}
                className="!text-gray-500"
              >
                Mark as Completed
              </MenuItem>
              <MenuItem
                onClick={() => handleClose({ inquiryId: param.id, status: 2 })}
                className="!text-gray-500"
              >
                Mark as Closed
              </MenuItem>
            </Menu>
          </div>

          {access?.inquery?.edit && (
            <Tooltip title="Edit">
              <IconButton
                onClick={() => handleAddEdit(param.id)}
                size="small"
                color="primary"
              >
                <EditRounded className="!text-[18px]" />
              </IconButton>
            </Tooltip>
          )}
          {access?.inquery?.followUp && (
            <Tooltip title="Follow Up">
              <IconButton
                onClick={() => handleFollowup(param)}
                size="small"
                color="primary"
                className="mr-5 p-5"
              >
                <BookmarkRounded className="fs-18 m-2" />
              </IconButton>
            </Tooltip>
          )}
          {access?.inquery?.delete && (
            <Tooltip title="Delete">
              <IconButton
                onClick={() => handleDlt(param.id)}
                size="small"
                color="error"
              >
                <ClearRounded className="!text-[18px]" />
              </IconButton>
            </Tooltip>
          )}
        </>
      )}
    </div>
  );
};

export default Actions;
